module.exports = __webpack_public_path__ + "static/media/close-cross.e35eb3f2.svg";